/**
 * "Let my agent use this tab" (docs/agents.md): the learner's own AI agent,
 * connected by an agent key, drives this tab through lib/agent-bridge.ts.
 *
 * One line while it is off. While it is on, what the agent did, newest
 * first, so nothing happens in the learner's name that they cannot see, and
 * a Stop that ends it at once.
 */
import { useSyncExternalStore } from 'react';
import { bridgeSnapshot, connectBridge, disconnectBridge, subscribeBridge } from '../../lib/agent-bridge';
import { useStrings } from '../../state/useLocale';

export function useBridge() {
  return useSyncExternalStore(subscribeBridge, bridgeSnapshot);
}

export function AgentStrip() {
  const s = useStrings().agents;
  const { state, log } = useBridge();
  const on = state === 'on' || state === 'connecting' || state === 'lost';

  if (!on) {
    return (
      <section className="block agent-strip">
        <p className="agent-strip-line">
          <button type="button" className="btn btn-quiet" onClick={connectBridge}>{s.connect}</button>
          {/* A new tab: a page load here would throw the running machine away. */}
          <a href="/agent" target="_blank" rel="noopener">{s.setUp}</a>
        </p>
        {state === 'taken-over' && <p className="note">{s.takenOver}</p>}
      </section>
    );
  }

  return (
    <section className="block agent-strip" aria-live="polite">
      <p className="agent-strip-line">
        <strong>{state === 'on' ? s.connected : state === 'lost' ? s.lost : s.connecting}</strong>
        <button type="button" className="btn btn-quiet" onClick={disconnectBridge}>{s.stop}</button>
      </p>
      <p className="note">{s.explain}</p>
      {log.length > 0 && (
        <ul className="agent-log">
          {log.map((entry) => (
            <li key={`${entry.at}:${entry.what}:${entry.detail}`} className={entry.failed ? 'is-fail' : undefined}>
              {s.did[entry.what]} {entry.detail && <code dir="ltr">{entry.detail}</code>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
